import React, { useState, useEffect } from "react";
import Header from "../common/header";
import Sidebar from "../common/navBar";
import CommonCard from "../common/commonCard";
import { Container, Row, Col } from "react-bootstrap";
import CustomTable from "../common/table";
import Footer from "../common/footer";
import { GetNotificationsService } from "../../Services/notificationService";
import { useTranslation } from "react-i18next";

const Notification = () => {
  const [t] = useTranslation("notifications")
  const [expanded, setExpanded] = useState(false);
  const [notificationsData, setNotificationsData] = useState([]);
  const [loading, setLoading] = useState(true);


  async function fetchData() {
    try {
      setNotificationsData([]);
      const response = await GetNotificationsService(t);
      setNotificationsData(response);
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('Hubo un error al obtener los datos de los usuarios', error);
    }
  }

  useEffect(() => {

    fetchData();
  }, []);



  const handleReloadData = () => {

    fetchData();
  };

  const columnHeaders = [`${t("notificationsTable.createdAt")}`, `${t("notificationsTable.view")}`, `${t("notificationsTable.notificationContent")}`];

  const fieldsToShow = ["createdAt", "view", "notificationContent"];
  const optionArrays = [[], [`${t("notificationsTable.stateDataTrue")}`, `${t("notificationsTable.stateDataFalse")}`], []];

  return (
    <div>
      <Header
        manual={'https://www.myreportin.com/descargas/manual-de-usuario-Myreportin.pdf'}
        reloadData={handleReloadData}
      />
      <Container fluid>
        <Row>
          <Col
            className='d-flex'
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "2%" : "4%"}`,
            }}
          >
            <Sidebar expanded={expanded} setExpanded={setExpanded} />
          </Col>
          <Col
            className='custom-content-wrapper'
            style={{
              marginLeft: `0.5%`,
              paddingRight: 0,
              flex: `0 0 ${expanded ? "86%" : "93%"}`,
            }}
          >
            <CommonCard title={t("card.title")} icon={"FaBell"}>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >

                <CustomTable
                  key={loading}
                  columnHeaders={columnHeaders}
                  fieldsToShow={fieldsToShow}
                  data={notificationsData}
                  optionArrays={optionArrays}
                  // defaultFilterField={'view'}
                  // defaultFilterDirection={'asc'}
                  navigateTo={'/incident'}
                  loading={loading}
                  viewButton
                  notificationsTable
                  editButton={false}
                  requiredReloadData={handleReloadData}
                />
              </div>
            </CommonCard>
            <Footer />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Notification;
